<template>
  <div class="">
    <el-button type="primary" v-if="cardList.length == 0" @click="openAdd">添加会员卡</el-button>
    <div class="grid">
      <el-card class="box-card" v-for="(v, i) in cardList" :key="i">
        <div slot="header" class="clearfix">
          <span>{{ v.name }}</span>
          <el-button
            style="float: right; padding: 3px 7px"
            type="text"
            @click="openBind(v)"
            >可用场地</el-button
          >
          <el-button
            style="float: right; padding: 3px 7px"
            type="text"
            @click="openSend(v)"
            >发卡</el-button
          >
        </div>
        <h3>
          绑定场馆
        </h3>
        <div v-for="(venue,n) in v.binds" :key="n" class="b-item">
          <div class="v-name"> {{venue.venue_name}}</div>
         
           <el-button
            style="float: right; padding: 3px 7px"
            type="text"
            @click="openBenefit(v,venue)"
            >福利日</el-button
          >
        </div>
      </el-card>
    </div>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
    </auto-table>

    <editCard ref="add"></editCard>
    <bindMec ref="bind"></bindMec>
    <sendVenueMember ref="send"></sendVenueMember>

    <benefit ref="benefit"></benefit>
  </div>
</template>

<script>
import benefit from '../benefit/benefit.vue';
import bindMec from "./bindMec.vue";
import editCard from "./editCard.vue";
import sendVenueMember from "./sendVenueMember.vue";
export default {
  components: {
    editCard,
    bindMec,
    sendVenueMember,
    benefit
  },

  data() {
    return {
      cardList: [],
      DataList: [],
      Option: [
        { name: "会员卡", value: "card_name" },
        { name: "持卡人", value: "name" },
        { name: "过期时间", value: "expired_time" },
        { name: "发卡时间", value: "create_time"},
      ],
      Total: 0,
      cooperator_id: "",
    };
  },

  mounted() {
    this.cooperator_id = this.$route.query.id;
  },

  methods: {
    load() {
      if (this.DataList.length == 0) {
        this.getCoopCard();
        this.getList(1);
      }
    },
    openSend(v) {
      this.$refs.send.open(v);
    },
    openAdd() {
      this.$refs.add.open();
    },
    openBenefit(card,v){
      let param = {
        id: card.id,
        venue_id: v.venue_id,
        mechanism_id: v.mechanism_id
      }
      this.$refs.benefit.open(param);
    },
    openBind(v) {
      this.$refs.bind.open(v);
    },
    toDetail(row) {
      this.$router.push({ name: "mecDetails", query: { mecID: row.id } });
    },
    getCoopCard() {
      this.$axios({
        url: "/user/mechanismCard/queryCoopCardList",
        params: {
          coop_id: this.cooperator_id,
        },
      }).then((res) => {
        this.cardList = res.data.data;
      });
    },
    //分成记录
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/mechanismCardUser/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          coop_id: this.cooperator_id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.b-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 7px 10px;
   margin-top: 10px;
}

.v-name {
  font-size: 14px;
}
</style>